import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Icon } from '@/components/Icon';
import { describeError, reportClientError } from '@/errorReporting/reporter';

/** Router-level error screen; keeps the shell chrome from disappearing. */
export function ErrorBoundary() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong.';

  // Reported once per distinct error (the beacon dedups): a render error also
  // reaches main.tsx's onCaughtError with the same message and stack, and a
  // route error response (a thrown 404) reaches only this. A chunk that failed
  // to load is reported as `chunk_load`; the Reload below is its fix.
  useEffect(() => {
    if (isRouteErrorResponse(error)) {
      reportClientError({ kind: 'boundary', message: `Route error ${error.status} ${error.statusText}` });
    } else {
      reportClientError({ kind: 'boundary', ...describeError(error) });
    }
  }, [error]);

  return (
    <div className="empty-state">
      <Icon name="offline" size={32} />
      <p className="empty-state__title">This view failed to load</p>
      <p className="muted">{message}</p>
      <button type="button" className="btn" onClick={() => window.location.reload()}>
        Reload
      </button>
    </div>
  );
}
